import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-column-table',
  templateUrl: './custom-column-table.component.html',
  styleUrls: ['./custom-column-table.component.css']
})
export class CustomColumnTableComponent {
  @Input() label!: string;
  @Input() field?: string;
  @Input() sorteable?: boolean = false;
}
